import React, { useState, useEffect } from "react";
import "./PopupButton.css"; // Import the CSS file

const PopupButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      <button
        className={`fa fa-arrow-up popup-button hover:scale-110 transition-transform duration-300 ease-in-out ${isVisible ? "visible" : ""}`}
        onClick={handleClick}
      >
      </button>
      <button
        className={`fa fa-phone popup-button hover:scale-110 transition-transform duration-300 ease-in-out ${isVisible ? "visible" : ""}`}
        onClick={() => window.location.href = `tel:+43662432330`}
      >
      </button>
    </>
  );
};

export default PopupButton;
